import { AppContainer } from '../../b2c/AppContainer.mjs';
import { createB2CComponent } from '../bindings/createB2CComponent.mjs';

/**
 * The Stytch Login Screen component.
 * This component can only be used with a Stytch UI Client
 * passed into the StytchProvider.
 *
 * See the {@link https://stytch.com/docs/sdks online reference}
 *
 * @example
 * <StytchLogin
 *   config={{
 *     products: [Products.emailMagicLinks, Products.oauth],
 *     emailMagicLinksOptions: {
 *       loginRedirectURL: 'https://example.com/authenticate',
 *       signupRedirectURL: 'https://example.com/authenticate',
 *     },
 *     oauthOptions: {
 *      providers: [{ type: OAuthProviders.Google }, { type: OAuthProviders.Microsoft }],
 *    },
 *   }}
 *   presentation={{
 *     theme: { primary: '#0577CA' },
 *     options: {},
 *   }}
 *   callbacks={{
 *     onEvent: (event) => console.log(event)
 *   }}
 * />
 */ const StytchLogin = /* @__PURE__ */ createB2CComponent('StytchLogin', AppContainer);

export { StytchLogin };
//# sourceMappingURL=StytchLogin.mjs.map
